import {createNode} from "./common/ui";

(function () {
	const settings = {
		deliveryIcon: {
			office: '',
			delivery: ''
		},
		defaultWeightValue: 0.1
	};

	function amountString(amountObj) {
		switch (amountObj.currency) {
			case 'USD':
				return `${amountObj.amount}$`;
			case 'RUB':
				return `${amountObj.amount}₽`;
			default:
				return amountObj.amount;
		}
	}
	
	function isTariffsPage() {
		return window.location.pathname.endsWith('tariffs.html')
	}

	function initUi() {
		let parametersChangedHandler;
		let countryParametersChangedHandler;
		const form = document.querySelector('.sys__calc-form');
		const countriesRadios = document.querySelectorAll('[name=calc__country]');
		const citySelect = document.querySelector('[name=calc__city]');
		const weightInput = document.querySelector('[name=calc__weight]');
		const weightRadios = document.querySelectorAll('[name=calc__weight-item]');
		const resultsNode = document.querySelector('.sys__calculator-results');
		const resultHeadlineNode = document.querySelector('.sys__calculator-headline');
		const resultFootnoteNode = document.querySelector('.sys__calculator-footnote');
		const deliveryMethodsRatePostOffice = document.querySelector('.sys__delivery-methods-rate.sys__delivery-methods-post-office'); //only on tariffs page
		const deliveryMethodsTimePostOffice = document.querySelector('.sys__delivery-methods-delivery-time.sys__delivery-methods-post-office'); //only on tariffs page
		const deliveryMethodsRateProPostOffice = document.querySelector('.sys__delivery-methods-rate.sys__delivery-methods-pro-post-office'); //only on tariffs page
		const deliveryMethodsTimeProPostOffice = document.querySelector('.sys__delivery-methods-delivery-time.sys__delivery-methods-pro-post-office'); //only on tariffs page
		const deliveryMethodsRateCourier = document.querySelector('.sys__delivery-methods-rate.sys__delivery-methods-courier'); //only on tariffs page
		const deliveryMethodsTimeCourier = document.querySelector('.sys__delivery-methods-delivery-time.sys__delivery-methods-courier'); //only on tariffs page
		const deliveryMethodsRateProCourier = document.querySelector('.sys__delivery-methods-rate.sys__delivery-methods-pro-courier'); //only on tariffs page
		const deliveryMethodsTimeProCourier = document.querySelector('.sys__delivery-methods-delivery-time.sys__delivery-methods-pro-courier'); //only on tariffs page
		const deliveryMethodsRateAsterisk = document.querySelector('.sys__delivery-methods-rate.sys__delivery-methods-asterisk') //only on tariffs page
		const deliveryMethodsTimeAsterisk = document.querySelector('.sys__delivery-methods-delivery-time.sys__delivery-methods-asterisk') //only on tariffs page
		const deliveryMethodPostOfficeValues = document.querySelectorAll('.sys__delivery-methods-post-office'); //only on tariffs page
		const deliveryMethodCourierValues = document.querySelectorAll('.sys__delivery-methods-courier'); //only on tariffs page
		const deliveryMethodProPostOfficeValues = document.querySelectorAll('.sys__delivery-methods-pro-post-office'); //only on tariffs page
		const deliveryMethodProCourierValues = document.querySelectorAll('.sys__delivery-methods-pro-courier'); //only on tariffs page

		const debounceSnapshot = {
			lastCall: undefined,
			lastCallTimer: undefined
		}

		function calculatorParams(opts) {
			const values = {
				departureCountry: [...countriesRadios].filter(radioButton => radioButton.checked).map(radioButton => radioButton.value)[0],
				destinationCity: citySelect ? citySelect.value : '',
				weight: !!opts && opts['weight'] ? opts['weight'] : weightInput.value
			};
			const stringValue = JSON.stringify(values);
			return {...values, stringValue};
		}

		function debounce(callee, timeoutMs) {
			return function perform(...args) {
				let previousCall = debounceSnapshot.lastCall

				debounceSnapshot.lastCall = Date.now()

				if (previousCall && debounceSnapshot.lastCall - previousCall <= timeoutMs)
					clearTimeout(debounceSnapshot.lastCallTimer)

				debounceSnapshot.lastCallTimer = setTimeout(() => callee(...args), timeoutMs)
			}
		}

		function onParamsChanged() {
			if (typeof parametersChangedHandler === 'function') {
				const params = calculatorParams();
				writeEmptyRates(params.departureCountry);

				const debouncedHandle = debounce(parametersChangedHandler, 300);
				debouncedHandle(params)
			}
		}

		function createRateCardNode(title, delivery, price, hint, icon, iconFrameCssClass) {
			const result = createNode('p', 'shipping-calculator__result-rate');
			const card = createNode('span', 'shipping-calculator__result-rate-card');
			const cardContainer = createNode('span', 'shipping-calculator__result-rate-card-container');
			const cardHint = createNode('span', 'shipping-calculator__result-rate-hint');
			cardHint.appendChild(createNode('span', undefined, { innerHTML: hint.content }));
			if (hint.hasOwnProperty('tooltipContent')) {
				cardHint.appendChild(createNode('img', undefined, {
					src: "/icons/i.svg",
					alt: 'tooltip',
					width: 15,
					height: 15
				}));
				const cardHintTooltip = createNode('span', 'shipping-calculator__result-rate-hint-tooltip');
				const cardHintTooltipContent = createNode('span', undefined, { innerText: hint.tooltipContent}); 
				cardHintTooltip.appendChild(cardHintTooltipContent);
				if (hint.hasOwnProperty('tooltipLink')) {
					const cardHintTooltipLink = createNode('a', 'shipping-calculator__result-rate-hint-tooltip-link');
					Object.assign(cardHintTooltipLink, hint.tooltipLink);
					cardHintTooltip.appendChild(cardHintTooltipLink);
				}
				cardHint.appendChild(cardHintTooltip)
			}
			const cardIcon = createNode('span', 'shipping-calculator__result-rate-icon');
			if (iconFrameCssClass) {
				cardIcon.classList.add(iconFrameCssClass);
			}
			if (icon) {
				const cardIconImage = document.createElement('img');
				cardIconImage.src = `/icons/${icon}`;
				cardIconImage.alt = '';
				cardIcon.appendChild(cardIconImage);
			}
			const rateDescription = createNode('span', 'shipping-calculator__result-rate-description');
			const rateDescriptionName = createNode('span', 'shipping-calculator__result-rate-name');
			rateDescriptionName.innerText = title;
			const rateDescriptionDelivery = createNode('span', 'shipping-calculator__result-rate-delivery')
			rateDescriptionDelivery.innerText = delivery;
			const rateDescriptionPrice = createNode('span', 'shipping-calculator__result-rate-price');
			rateDescriptionPrice.innerHTML = price;
			rateDescription.appendChild(rateDescriptionName);
			rateDescription.appendChild(rateDescriptionDelivery);
			rateDescription.appendChild(rateDescriptionPrice);
			cardContainer.appendChild(cardIcon);
			cardContainer.appendChild(rateDescription);
			card.appendChild(cardContainer);
			card.appendChild(cardHint);
			result.appendChild(card);
			return result;
		}

		function createEmptyRateCartNode() {
			return createRateCardNode('', '', '&nbsp;', {content: '&nbsp;'})
		}

		function createFilledRateCartNode(rate, hint, icon) {
			return createRateCardNode(rate.title, rate.terms, amountString(rate.price), hint, icon);
		}

		function writeEmptyRates(departureCountry) {
			resultsNode.innerHTML = '';
			resultsNode.appendChild(createEmptyRateCartNode());
			
			if (departureCountry !== 'CN')
				resultsNode.appendChild(createEmptyRateCartNode());
			
			if (departureCountry === 'US') {
				resultsNode.appendChild(createEmptyRateCartNode());
				resultsNode.appendChild(createEmptyRateCartNode());
			}
		}

		function getFootnoteRate(departureCountry) {
			switch (departureCountry) {
				case 'US':
				case 'DE':
				case 'CN':
					return `* стоимость доставки посылки 0,1 кг`;
				case 'AE':
				case 'TR':
					return `* стоимость доставки посылки до 1 кг`;
				default:
					return '';
			}
		}

		function getFootnoteTime(departureCountry) {
			switch (departureCountry) {
				case 'US':
				case 'DE':
				case 'CN':
					return `** срок доставки до Москвы`;
				case 'AE':
				case 'TR':
					return `** срок доставки от склада до Москвы`;
				default:
					return '';
			}
		}

		function getFootnotes(departureCountry){
			switch (departureCountry) {
				case 'US':
					return ['Нет доставки в республику Крым, Севастополь, ЛНР, ДНР, Запорожскую и Херсонскую области.', '*Для таможенного оформления необходимо предоставить паспортные данные и ИНН.'];
				case 'DE':
					return ['Общая стоимость товаров в посылке не должна превышать 1000€.', 'Нет доставки в республику Крым, Севастополь, ЛНР, ДНР, Запорожскую и Херсонскую области.'];
				case 'AE':
					return ['Для таможенного оформления посылок из ОАЭ необходимо предоставить паспортные данные. <a href="/help.html#OformildostavkuizOAEMneprishlosoobshhenieotomchtonuzhnopredostavitpasportnyedannyeZachemvyixsobiraete">Подробнее</a>'];
				case 'TR':
					return ['Для таможенного оформления посылок из Турции необходимо предоставить паспортные данные. <a href="/help.html#OformildostavkuizOAEMneprishlosoobshhenieotomchtonuzhnopredostavitpasportnyedannyeZachemvyixsobiraete">Подробнее</a>'];
				case 'CN':
					return ['Общая стоимость товаров в посылке не должна превышать 5000 юаней.'];
				default:
					return [];
			}
		}
		
		function toggleDeliveryMethodColumnVisibility(values, hasRate) {
			values.forEach(element => {
				element.classList.toggle('delivery-methods__value--hidden', !hasRate);
			})
		}

		for (let countryRadio of countriesRadios) {
			countryRadio.addEventListener('change', function () {
				onParamsChanged();

				// resultFootnoteNode.classList.toggle('shipping-calculator__result-footnote--hidden',countryRadio.value !== 'US');
				resultFootnoteNode.innerHTML = '';
				getFootnotes(countryRadio.value).forEach(footnote => {
					const footnoteNode = createNode('p', 'shipping-calculator__result-footnote', {
						innerHTML: footnote
					})
					resultFootnoteNode.appendChild(footnoteNode);
				})

				if (isTariffsPage()) {
					countryParametersChangedHandler(calculatorParams({weight: `${settings.defaultWeightValue}`}));
				}
			});
		}
		citySelect && citySelect.addEventListener('change', onParamsChanged);
		weightInput.addEventListener('input', function () {
			for (let weightRadio of weightRadios) {
				weightRadio.checked = false;
			}
			onParamsChanged();
		});

		for (let weightRadio of weightRadios) {
			weightRadio.addEventListener('change', function () {
				weightInput.value = weightRadio.value;
				onParamsChanged();
			});
		}

		form.addEventListener('submit', function (submitEvent) {
			submitEvent.preventDefault();
			onParamsChanged();
		});

		return {
			onParametersChanged: (newParametersChangedHandler, newCountryParametersChangedHandler) => {
				parametersChangedHandler = newParametersChangedHandler;
				countryParametersChangedHandler = newCountryParametersChangedHandler;
			},
			parameters: params => calculatorParams(params),
			clearRates: () => resultsNode.innerHTML = '',
			writeOfficeRate: (rate, departureCountry) => {
				const rateCardNode = createFilledRateCartNode(
					rate,
					{
						content: departureCountry === 'US' 
							? 'Доставка до почтового отделения. Без сбора паспортных данных'
							: 'Доставка до почтового отделения'
					},
					'standard-delivery2.svg'
				);
				return resultsNode.appendChild(rateCardNode);
			},
			writeCourierRate: (rate, departureCountry) => {
				const rateCardNode = createFilledRateCartNode(
					rate,
					{
						content: departureCountry === 'US'
							? 'Доставка до двери. Без сбора паспортных данных'
							: 'Доставка до двери'
					},
					'courier.svg'
				);
				return resultsNode.appendChild(rateCardNode);
			},
			writeProOfficeRate: rate => {
				rate.title = `${rate.title}*`
				const rateCardNode = createFilledRateCartNode(
					rate,
					{
						content: 'Быстрая доставка до отделения почты. Привезём электронику',
					},
					'pro-delivery.svg'
				);
				return resultsNode.appendChild(rateCardNode);
			},
			writeProCourierRate: rate => {
				rate.title = `${rate.title}*`
				const rateCardNode = createFilledRateCartNode(
					rate,
					{
						content: 'Быстрая доставка до двери. Привезём электронику',
					},
					'courier-pro-delivery.svg'
				);
				return resultsNode.appendChild(rateCardNode);
			},
			writeHeadline: hasRates => {
				resultHeadlineNode.innerHTML = hasRates ? 'Примерная стоимость доставки' : 'Превышен лимит по весу'
			},
			updateDeliveryMethodsPostOffice: rate => {
				deliveryMethodsRatePostOffice.innerHTML = `от ${amountString(rate.price)}`;
				deliveryMethodsTimePostOffice.innerHTML = rate.terms;
			},
			updateDeliveryMethodsProPostOffice: rate => {
				deliveryMethodsRateProPostOffice.innerHTML = `от ${amountString(rate.price)}`;
				deliveryMethodsTimeProPostOffice.innerHTML = rate.terms;
			},
			updateDeliveryMethodsCourier: rate => {
				deliveryMethodsRateCourier.innerHTML = `от ${amountString(rate.price)}`;
				deliveryMethodsTimeCourier.innerHTML = rate.terms;
			},
			updateDeliveryMethodsProCourier: rate => {
				deliveryMethodsRateProCourier.innerHTML = `от ${amountString(rate.price)}`;
				deliveryMethodsTimeProCourier.innerHTML = rate.terms;
			},
			updateDeliveryMethodsAsteriskInfo: departureCountry => {
				deliveryMethodsRateAsterisk.innerHTML = getFootnoteRate(departureCountry)
				deliveryMethodsTimeAsterisk.innerHTML = getFootnoteTime(departureCountry);
			},
			toggleDeliveryMethodsValues: (hasOfficeRate, hasCourierRate, hasProOfficeRate, hasProCourierRate) => {
				toggleDeliveryMethodColumnVisibility(deliveryMethodPostOfficeValues, hasOfficeRate);
				toggleDeliveryMethodColumnVisibility(deliveryMethodCourierValues, hasCourierRate);
				toggleDeliveryMethodColumnVisibility(deliveryMethodProPostOfficeValues, hasProOfficeRate);
				toggleDeliveryMethodColumnVisibility(deliveryMethodProCourierValues, hasProCourierRate);
			},
			isTariffsPage: isTariffsPage,
			countryIsoCodes: () => [...countriesRadios].map(radioButton => radioButton.value),
		};
	}

	function getRates(dispatchParams, onRatesReceived) {
		fetch(
			'https://kupishop.eleview.com/api/pg/Calculator/LandingRates',
			{
				method: 'POST',
				headers: {
					'accept': 'application/json',
					'Content-Type': 'application/json;charset=utf-8'
				},
				body: JSON.stringify({
					fromCountryIsoCode: dispatchParams.departureCountry,
					toCountryIsoCode: 'RU',
					weightInKg: dispatchParams.weight,
					uiLocale: 'RuRu'
				})
			}
		).then(
			function (response) {
				response.json().then(function (parsedJson) {
					onRatesReceived(parsedJson, dispatchParams);
				});
			}
		);
	}

	function isUSContext(countryIsoCodes) {
		if (!localStorage.hasOwnProperty('context') || localStorage.context === 'US') 
			return true;

		return !countryIsoCodes.includes(localStorage.context);
	}

	function initCalculator() {
		const ui = initUi();
		let lastRequestedParams = '';

		function recalculateRates(params) {
			lastRequestedParams = params.stringValue;
			getRates(params, function (rates, forParams) {
				if (lastRequestedParams === forParams.stringValue && Object.entries(rates).length !== 0) {
					ui.clearRates();
					if (rates.hasOwnProperty('hasRates')) {
						ui.writeHeadline(rates.hasRates)
						if (rates.hasOwnProperty('postalOfficeRate')) {
							ui.writeOfficeRate(rates.postalOfficeRate, params.departureCountry);
						}
						if (rates.hasOwnProperty('courierRate')) {
							ui.writeCourierRate(rates.courierRate, params.departureCountry);
						}
						if (rates.hasOwnProperty('proPostalOfficeRate')) {
							ui.writeProOfficeRate(rates.proPostalOfficeRate);
						}
						if (rates.hasOwnProperty('proCourierRate')) {
							ui.writeProCourierRate(rates.proCourierRate);
						}
					}
				}
			});
		}

		function recalculateDeliveryMethodRates(params) {
			getRates(params, function (rates, _) {
				if (Object.entries(rates).length !== 0) {
					if (rates.hasOwnProperty('postalOfficeRate')) {
						ui.updateDeliveryMethodsPostOffice(rates.postalOfficeRate);
					}
					if (rates.hasOwnProperty('courierRate')) {
						ui.updateDeliveryMethodsCourier(rates.courierRate);
					}
					if (rates.hasOwnProperty('proPostalOfficeRate')) {
						ui.updateDeliveryMethodsProPostOffice(rates.proPostalOfficeRate);
					}
					if (rates.hasOwnProperty('proCourierRate')) {
						ui.updateDeliveryMethodsProCourier(rates.proCourierRate);
					}

					ui.toggleDeliveryMethodsValues(
						rates.hasOwnProperty('postalOfficeRate'),
						rates.hasOwnProperty('courierRate'),
						rates.hasOwnProperty('proPostalOfficeRate'),
						rates.hasOwnProperty('proCourierRate'),
					);
					ui.updateDeliveryMethodsAsteriskInfo(params.departureCountry);
				}
			});
		}

		ui.onParametersChanged(recalculateRates, recalculateDeliveryMethodRates);

		if (isUSContext(ui.countryIsoCodes())){
			recalculateRates(ui.parameters());

			if(ui.isTariffsPage()) {
				recalculateDeliveryMethodRates(ui.parameters({weight: `${settings.defaultWeightValue}`}));
			}
		}
	}

	document.addEventListener('DOMContentLoaded', initCalculator);
})();
